import { isBedbankOffer, isCruiseOffer, isExperienceOffer, isTourV2Offer } from './offerTypes'

export function isDisplayablePrice(price: number | null | undefined): price is number {
  return typeof price === 'number' && Number.isFinite(price) && price > 0
}

export function hasDisplayablePackagePrice<T extends { price?: number | null }>(pkg?: T | null): pkg is T & { price: number } {
  return isDisplayablePrice(pkg?.price)
}

export function hasDisplayableOfferPrice(offer: App.AnyOffer | undefined): boolean {
  if (!offer) return false

  if (isTourV2Offer(offer)) {
    return offer.purchasableOptions.some(option => isDisplayablePrice(option.price))
  }

  if (isCruiseOffer(offer)) {
    return isDisplayablePrice(offer.mainDepartureDetails?.lowestOverallPriceDetails?.total)
  }

  if (isExperienceOffer(offer)) {
    return isDisplayablePrice(offer.price)
  }

  if (isBedbankOffer(offer)) {
    return isDisplayablePrice(offer.sell?.price)
  }

  const hasBundlePrice = 'lowestPriceBundlePackage' in offer &&
    hasDisplayablePackagePrice(offer.lowestPriceBundlePackage)
  const hasPackagePrice = 'lowestPricePackage' in offer &&
    hasDisplayablePackagePrice(offer.lowestPricePackage)

  return hasBundlePrice || hasPackagePrice
}
